const icon = require('vue-svgicon');
icon.register({
    'vkontakte': {
        width: 48,
        height: 48,
        viewBox: '0 0 48 48',
        data: `<path pid="0" d="M25.34 33.72C15.09 33.72 9.244 26.693 9 15h5.134c.169 8.582 3.954 12.217 6.952 12.967V15h4.835v7.402c2.96-.319 6.07-3.692 7.12-7.402h4.835c-.806 4.572-4.18 7.945-6.578 9.332 2.399 1.124 6.24 4.066 7.702 9.388h-5.322c-1.143-3.56-3.99-6.315-7.757-6.69v6.69h-.581z" _fill="#000"/>`,
    },
});
